import { render } from "./WebhooksTable.vue?vue&type=template&id=9437180a"
import script from "./WebhooksTable.vue?vue&type=script&lang=js"
export * from "./WebhooksTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__